import Layout from '../components/Layout';
import ResultSearch from '../components/resultSearch';


const Search = () => {

	return (
		<Layout
			pagina={"Búsqueda"}
		>
			<div className='w-full pt-20 pb-20'>
                <ResultSearch/>
			</div>
		</Layout>
	)
}

export default Search